<template>
<div class="kt-list-timeline__item">
    <span class="kt-list-timeline__badge"></span>
    <span class="kt-list-timeline__text">
        <slot></slot>
    </span>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>